import { useEffect, useState } from 'react';

/** The time now, in milliseconds, renewed every `intervalMs` so a page can count with it. */
export const useNow = (intervalMs: number = 1000): number => {
  const [now, setNow] = useState(Date.now);

  useEffect(() => {
    const timer = setInterval(() => {
      setNow(Date.now());
    }, intervalMs);

    return () => {
      clearInterval(timer);
    };
  }, [intervalMs]);

  return now;
};
